import { CourseImage } from "./MappedCourse"
import { FilledImageFieldImage, PrismicDocument } from "@prismicio/types"
import { slugifyCourse } from "./common"
import { RichText } from "prismic-reactjs"
import { htmlSerializer } from "./htmlSerializer"

export interface PressMentionPost {
  id: string
  slugifyName: string
  numberId: number
  slug: string
  url?: string
  name: string
  excerpt: React.ReactNode
  excerptAsText: string
  content: React.ReactNode
  image?: CourseImage
  tags?: string[]
  photoGallery?: FilledImageFieldImage[]
  highlighted: boolean
}

export const getPressMentionPost = (d: PrismicDocument<any>): PressMentionPost => {
  const { slugify_name, number_id, slug } = slugifyCourse(d)

  return {
    id: d.id,
    slugifyName: slugify_name,
    numberId: number_id,
    slug,
    url: d.data?.url?.url || undefined,
    name: (d.data.title[0] && d.data.title[0].text) || "",
    excerpt: d.data?.excerpt ? <RichText render={d.data.excerpt} htmlSerializer={htmlSerializer} /> : null,
    excerptAsText: (d.data.excerpt[0] && d.data.excerpt[0].text) || "",
    content: d.data?.content ? <RichText render={d.data.content} htmlSerializer={htmlSerializer} /> : null,
    image: d.data.image || d.data.content.find((c) => c.type === "image") || undefined,
    tags: d?.tags || [],
    photoGallery: (d.data?.["photo_gallery"]?.data?.images || []).map((g) => g.image) as FilledImageFieldImage[],
    highlighted: d.data?.highlighted || false
  }
}
